export class ScormMock {
    constructor() {
        this.win = window;
    }
    ensureAPI() {
        const API = this.win.API;
        if (API && !!API.isMock) {
            console.log('SCRORM window.API already defined skipping mock');
        }
        else {
            this.win.API = (() => {
                return {
                    isMock: true,
                    LMSInitialize: () => {
                        return 'true';
                    },
                    LMSCommit: () => {
                        return 'true';
                    },
                    LMSFinish: () => {
                        return 'true';
                    },
                    LMSGetValue: model => {
                        return '';
                    },
                    LMSSetValue: (model, value) => {
                        return 'true';
                    },
                    LMSGetLastError: () => {
                        return '0';
                    },
                    LMSGetErrorString: errorCode => {
                        return 'No error';
                    },
                    LMSGetDiagnostic: errorCode => {
                        return 'No error';
                    }
                };
            })();
        }
        const API_1484_11 = this.win.API_1484_11;
        if (API_1484_11 && !!API_1484_11.isMock) {
            console.log('SCRORM window.API_1484_11 already defined skipping mock');
        }
        else {
            this.win.API_1484_11 = (() => {
                return {
                    isMock: true,
                    Initialize: () => {
                        return 'true';
                    },
                    Commit: () => {
                        return 'true';
                    },
                    Terminate: () => {
                        return 'true';
                    },
                    GetValue: model => {
                        return '';
                    },
                    SetValue: (model, value) => {
                        return 'true';
                    },
                    GetLastError: () => {
                        return '0';
                    },
                    GetErrorString: errorCode => {
                        return 'No error';
                    },
                    GetDiagnostic: errorCode => {
                        return 'No error';
                    }
                };
            })();
        }
    }
    destroy() {
        const API = this.win.API;
        if (API && API.isMock) {
            delete this.win.API;
        }
        const API_1484_11 = this.win.API_1484_11;
        if (API_1484_11 && API_1484_11.isMock) {
            delete this.win.API_1484_11;
        }
    }
}
//# sourceMappingURL=scorm.mock.js.map